module.exports = __webpack_public_path__ + "img/oth5.4496292c.png";